<script setup lang="ts">
/**
 * This base modal wrapper contains stylings to be applied to modals throughout
 * the app. Takes title, content, and actions slots. Required modelValue
 * (use v-model="someRef") to cascade visibility down to the dialog
 * component.
 */
import { useModelWrapper } from './helpers/useModelWrapper'
const props = defineProps<{
  modelValue: boolean
}>()
const emit = defineEmits<{
  (e: 'update:modelValue', data: any): void
}>()

const value = useModelWrapper(props, emit)
</script>

<template>
  <q-dialog v-model="value">
    <q-card class="q-pa-md" style="min-width: 24rem">
      <q-card-section>
        <div class="text-h6">
          <slot name="title" />
        </div>
      </q-card-section>
      <q-card-section class="q-mb-md">
        <slot name="content" />
      </q-card-section>
      <q-card-actions align="right" class="no-padding">
        <div class="q-gutter-sm">
          <slot name="actions" />
        </div>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
